if not App.angularApp?
    return

App.angularApp.directive 'noNg', () ->
    return {
        priority: 1000
        compile: (elem, attrs) ->
            attrs.$set('ngClick', '$event.stopPropagation()')
    }
